module.exports = __webpack_public_path__ + "static/img/17.0aa93280.png";